(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets-receipt/digital-tickets-receipt.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets-receipt/digital-tickets-receipt.js');
"use strict";

const {
  Fragment,
  useContext,
  useEffect,
  useState
} = React;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  PageWrapper
} = svs.ticket_partner.sharedComponents.pageWrapper;
const {
  WidgetArea
} = svs.ticket_partner.sharedComponents.widgetArea;
const {
  InformationPanels
} = svs.ticket_partner.sharedComponents.informationPanels;
const {
  Receipt
} = svs.ticket_partner.sharedComponents.receipt;
const {
  DIGITAL_RECEIPT
} = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS;
const {
  CLEAR_STATE
} = svs.ticket_partner.digitalTickets.actions;
const {
  DIGITAL_TICKETS
} = svs.ticket_partner.constants.routes;
const DigitalTicketsReceipt = _ref => {
  var _svs$ticket_partner$d;
  let {
    history
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(svs.ticket_partner.DigitalTicketsContext);
  const {
    companyDetailsPromise,
    isLoggedIn
  } = useContext(svs.ticket_partner.UserContext);
  const [email, setEmail] = useState(null);
  useEffect(async () => {
    if (isLoggedIn) {
      const {
        companyDetails
      } = await companyDetailsPromise;
      setEmail(companyDetails.eMail);
    } else {
      var _state$registerNew;
      setEmail(state === null || state === void 0 || (_state$registerNew = state.registerNew) === null || _state$registerNew === void 0 ? void 0 : _state$registerNew.eMail);
    }
    if (state.orderSuccess) {
      dispatch({
        type: CLEAR_STATE
      });
    } else {
      history.push(DIGITAL_TICKETS);
    }
  }, []);
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(Receipt, {
    email: email,
    isLoggedIn: isLoggedIn,
    type: DIGITAL_RECEIPT
  })), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.digitalTrissArticles
  }), React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: 8,
    md: 10,
    sm: 12,
    xl: 6,
    xs: 12
  }, React.createElement(WidgetArea, {
    areaName: "digitalTrissAreaWidget"
  })))));
};
svs.ticket_partner.digitalTickets.DigitalTicketsReceipt = DigitalTicketsReceipt;

 })(window);